import { create } from 'zustand';
// this store managese loaded and failed image resources
export const useImageStore = create((set) => ({
    loadedResource: {},
    erroredResources: {},
    addErroredResource: (resourceId) => {
        set((state) => {
            if (state.erroredResources[resourceId]) {
                return state;
            }
            return {
                erroredResources: {
                    ...state.erroredResources,
                    [resourceId]: true,
                },
            };
        });
    },
    removeErroredResource: (resourceId) => {
        set((state) => {
            //multiple image variants could have failed, remove them all
            const errors = { ...state.erroredResources };
            Object.keys(errors).forEach((key) => {
                if (key.startsWith(resourceId)) {
                    delete errors[key];
                }
            });
            return {
                erroredResources: errors,
            };
        });
    },
    setLoadedResource: (resourceId, resource) => {
        set((state) => {
            return {
                loadedResource: {
                    ...state.loadedResource,
                    [resourceId]: resource,
                },
            };
        });
    },
    removeLoadedResource: (resourceId) => {
        set((state) => {
            const loadedResource = { ...state.loadedResource };
            delete loadedResource[resourceId];
            return {
                loadedResource,
            };
        });
    },
}));
//# sourceMappingURL=use-image-store.js.map